export default {"src":"/_next/static/media/customized-training-plan.67afb193.svg","height":289,"width":289,"blurWidth":0,"blurHeight":0};